import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ToasterService } from 'angular5-toaster';
import { TicketOffer } from '../../core/ticketOffer';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TramApiService } from '../../tram-api.service';
import { UserTicket } from '../../core/userTicket';
import { ModalComponent } from '../modal.component';
import { StorageService } from '../../storage.service';
import { HttpErrorResponse } from '@angular/common/http';
import { User } from '../../core/user';

@Component({
    selector: 'ticket-payment',
    templateUrl: './ticket-payment.component.html',
    styleUrls: ['./ticket-payment.component.scss']
})
export class TicketPaymentComponent {
    @ViewChild('modal') modal: ModalComponent;

    public isLoading: boolean;
    public paymentForm: FormGroup;
    public user: User;

    private totalCost: number;
    private totalTripsCount: number;

    private _tripsCount: number;
    get tripsCount(): number {
        return this._tripsCount;
    }

    @Input()
    set tripsCount(tripsCount: number) {
        this._tripsCount = tripsCount;

        this.updateTotalsForExistingTicket();
    }

    private _ticketOffer: TicketOffer;
    get ticketOffer(): TicketOffer {
        return this._ticketOffer;
    }

    @Input()
    set ticketOffer(ticketOffer: TicketOffer) {
        this._ticketOffer = ticketOffer;

        this.updateTotalsForNewTicket();
    }

    private _ticket: UserTicket;
    get ticket(): UserTicket {
        return this._ticket;
    }

    @Input()
    set ticket(ticket: UserTicket) {
        this._ticket = ticket;

        this.updateTotalsForExistingTicket();
    }

    @Output() opened = new EventEmitter();
    @Output() closed = new EventEmitter();

    constructor(
        private storage: StorageService,
        private api: TramApiService,
        private formBuilder: FormBuilder,
        private toaster: ToasterService) {
    }

    ngOnInit() {
        this.isLoading = true;
        if (this.storage.isSensitiveDataExist.value) {
            this.api.getCurrentUser()
                .then(user => {
                    this.user = user;
                    this.initForms(true);
                })
                .catch(() => this.initForms(false));
        } else {
            this.initForms(false);
        }
    }

    private initForms(isLoggedIn) {
        let controls: any = {
            acknowledged: [false, [
                Validators.required
            ]]
        };
        if (!isLoggedIn) {
            controls.email = ['', [
                Validators.email
            ]];
        }

        this.paymentForm = this.formBuilder.group(controls);
        
        this.isLoading = false;
    }

    private updateTotalsForNewTicket() {
        if (!this.tripsCount || !this.ticketOffer) return;

        this.totalCost = this.tripsCount * this.ticketOffer.cost;
        this.totalTripsCount = this.tripsCount + this.ticketOffer.bonusTripsCount;
    }

    private updateTotalsForExistingTicket() {
        if (!this.ticket) return;

        this.totalTripsCount = this.ticket.tripsCount;
        this.totalCost = this.ticket.cost;
    }

    private getOrCreateTicket(): Promise<UserTicket> {
        if (this.ticket) return Promise.resolve(this.ticket);

        let email = this.user ? this.user.email : this.paymentForm.value.email;

        return this.api.createTicket(this.tripsCount, this.ticketOffer.id, email)
            .then(ticket => {
                this.toaster.pop('success', null, 'Билет создан');
                
                this.ticket = ticket;
                return ticket;
            });
    }

    private handleError(error: HttpErrorResponse | string) {
        this.isLoading = false;
        if (error instanceof HttpErrorResponse) {
            this.toaster.pop('error', null, error.statusText);
        } else {
            this.toaster.pop('error', null, error);
        }
    }

    togglePaymentAcknowledged() {
        const acknowledged = this.paymentForm.get('acknowledged');
        acknowledged.setValue(!acknowledged.value);
    }

    pay() {
        this.isLoading = true;

        this.getOrCreateTicket()
            .then(ticket => this.api.payTicket(ticket.id))
            .then(paymentUrl => window.location.href = paymentUrl)
            .catch(err => this.handleError(err));
    }

    public open() {
        this.modal.open();
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/ticket/ticket-payment.component.ts